import api from '../../api';

const path = '/company/all/get';

export const getCompanyAllRequest = (id) => api.get(`${path}/${id}`);
export const getCompanyAllListRequest = (params) =>
    api.get(`${path}`, { params });
export const getCheckautoCompanyAllListRequest = (params) =>
    api.get(`/company/all/checkauto/get`, { params });
